export default "__VITE_ASSET__D$zFc0DI__"